module.exports = __webpack_public_path__ + "static/predictivepoem 36-01-2e96dbddb6c7486ac62380ec096d92ef.jpg";